module.exports = __webpack_public_path__ + "img/ring_r_0_null_1@3x.d7c320e9.png";